export const CLIP_REQUEST_GET_USER_REQUEST = "CLIP_REQUEST_GET_USER_REQUEST";
export const CLIP_REQUEST_GET_USER_RESULT = "CLIP_REQUEST_GET_USER_RESULT";